module.exports = __webpack_public_path__ + "static/img/043 2.dbe43c76.jpg";